import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "./assets/css/style_theme/theme/index.css";

import "./assets/css/quill.bubble.css";
import "./assets/css/quill.core.css";
import "./assets/css/quill.snow.css";

// 图片无缝轮播
import scroll from 'vue-seamless-scroll'

import axios from 'axios'

Vue.prototype.$http = axios;
// Vue.prototype.apiUrl = "http://127.0.0.1:21011";
// Vue.prototype.apiUrl = "http://192.168.31.16:21011";
// Vue.prototype.apiUrl = "http://gsjtjlapi.xiaoshuzn.com";
Vue.prototype.apiUrl = "http://api.cms.gsjtjl.com";

Vue.use(ElementUI, scroll);

// 日期dayjs
import dayjs from "dayjs"
Vue.prototype.dayjs = dayjs;

import VueAMap from 'vue-amap';
Vue.use(VueAMap);
// 初始化vue-amap
VueAMap.initAMapApiLoader({
    // 高德的key
    key: 'b4ec94ce069dbb1948540c8e25e0cccf',
    // 插件集合
    plugin: ['AMap.MouseTool', 'AMap.PolyEditor', 'AMap.LabelMarker', 'AMap.Autocomplete', 'AMap.ToolBar', 'AMap.PlaceSearch', 'AMap.Heatmap', 'AMap.Geocoder', 'AMap.DistrictSearch'],
    uiVersion: '1.0',
    // 高德 sdk 版本
    v: '1.4.15'
});

// css
import "./assets/css/publish.css";
import "./assets/css/style.css";

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");